<template>
<!--我的订单-->
  <div class="orders">
      <div class="titleWrap">
        <p class="titleName">我的能力</p>
        <span class="pull-right font14"><span @click.stop.prevent="backablity" style="cursor: pointer">我的能力</span> > 我的工作分</span>
      </div>
      <div class="showwrap">
        <div class="circleOut">
          <i-circle :percent="workPer" :size="184" :trail-width="4" :stroke-width="5" trail-color="#eeeff3" stroke-color="#957960" dashboard>
            <span class="demo-circle-inner" style="font-size:40px">{{workScore}}</span>
            <p class="mypoint">我的工作分</p>
          </i-circle>
          <span class="abilityTip font14" @click="goleida">能力雷达</span>
        </div>
        <!--<router-link to="/ziliao/job" class="add">-->
          <!--<Icon type="ios-add" :size="25"/>-->
          <!--<span>添加工作经历</span></router-link>-->
      </div>
      <p v-if="JSON.stringify(works) === '[]'" class="nojob">暂无工作经历</p>
      <span v-else>
        <ul class="inforList font14" v-for="work in works">
          <li>
            <p class="listLeft">工作经历</p>
            <!--<p class="listRight rightSet" v-if="work.isWork === 1"><img src="../../assets/renzheng.png" alt="" width="70"  ></p><p  v-else class="listRight rightSet"><img src="../../assets/norenzheng.png" alt="" width="70"></p>-->
            <p class="listRight rightSet" v-if="work.isWork === 1"><img src="../../assets/renzheng.png" alt="" width="70"  ></p><p  v-else class="listRight rightSet"><img src="../../assets/nopass.png" alt="" width="70"></p>
          </li>
          <li>
            <p class="listLeft">公司名称</p>
            <p class="listRight">{{work.companyName}}</p>
          </li>
          <li>
            <p class="listLeft">业态</p>
            <p class="listRight">{{work.operationType}}</p>
          </li>
          <li>
            <p class="listLeft">职位名称</p>
            <p class="listRight">{{work.position}}</p>
          </li>
          <li>
            <p class="listLeft">在职时间</p>
            <p class="listRight">{{work.workingLife.text}}</p>
          </li>
          <li>
            <p class="listLeft">工作描述</p>
            <p class="listRight">{{work.workTask}}</p>
          </li>
        </ul>
      </span>
    <Spin fix v-show="isSpinShow" >
      <div class="loader">
        <Icon type="ios-loading" size=26 class="demo-spin-icon-load"></Icon>
        <div class="font14">加载中...</div>
      </div>
    </Spin>
  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
  /* 旋转效果 */
  .demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
  }
  @keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50% { transform: rotate(180deg);}
    to { transform: rotate(360deg);}
  }
  /* 假如内容过长，一屏放不下，滚动条下拉覆盖不全 */
  .ivu-spin-fix {
    position: fixed;
  }

  .add:hover {
    border-color: #666;
    background-color: #f9f9f9;
  }

  .editorThis {
    color: #957960;
    padding: 0 0 0 20px;
    height: 22px;
    /*font-size: 16px;*/
    position: absolute;
    right: 0px;
    top: 2px;
    line-height: 20px;
    background: url("../../assets/edit.png") no-repeat left center;
    background-size: 14px;
    cursor: pointer;
  }
  .nojob{
    font-size: 14px;
    margin: 30px 0;
  }
  .titleWrap {
    height: 40px;
    font-size: 18px;
    padding-bottom: 20px;
    text-align: justify-all;
    border-bottom: 1px solid #E1E1E1;
    margin-bottom: 20px;
    color: #957960;
    .titleName {
      float: left;
      line-height: 24px;
      border-bottom: 3px solid #957960;
      padding-bottom: 13px;
      font-size: 14px;
    }
    .pull-right{
      /*font-size: 16px;*/
      color: #333;
    }
  }
  .suretips {
    display: inline-block;
    /*padding: 0 4px;*/
    height: 24px;
    /*background-color: #0a3c68;*/
    border-radius: 5px;
    color: #fff;
    text-align: center;
    img{
      vertical-align: middle;
      margin-right: 5px;
    }
  }
  .showwrap {
    text-align: center;
    .circleOut {
      display: inline-block;
      width: 260px;
      height: 260px;
      padding-top: 38px;
      background: url("../../assets/cricleBack.png") no-repeat center center;
      background-size: 260px;
    }
    .abilityTip{
      display: inline-block;
      height: 42px;
      padding: 0 15px;
      border-radius: 21px;
      text-align: center;
      line-height: 42px;
      background-color: #957960;
      color: #fff;
      min-width: 130px;
      cursor: pointer;
      /*font-size: 16px;*/
    }

  }
  .inforList {
    padding-top: 20px;
    border-bottom: 1px solid #e1e1e1;
    li {
      margin-bottom: 15px;
      position: relative;
      .listLeft {
        /*font-size: 16px;*/
        color: #666;
        float: left;
      }
      .listRight {
        margin: 0 0 0 90px;
        padding: 0 20px 0 0;
        /*font-size: 16px;*/
        color: #333;
        line-height: 24px;
      }
      .rightSet {
        margin-right: 70px;
        /*font-size: 16px;*/
        color: #333;
      }
    }
  }
  .inforList:last-child{
    border-bottom: none;
  }

</style>
<script type="text/ecmascript-6">
  import {myWorkPage,centreInfoWeb} from '../../http'
  import {getStore} from '../../storage'
    export default {
        name: 'orderdetail',
        props: {},
        data() {
            return {
              isSpinShow:false,
              workScore:0,    //工作分
              workPer:0,      //工作分比值
              works:'',       //工作经历
            };
        },
        methods: {
          //返回上级我的能力
          backablity(){
            this.$router.push({
              name:'ablity'
            })
          },
          goleida(){
            this.$router.push({
              name:'ablity_leida'
            })
          },
          getAblityJob(){
            if(this.isSpinShow === false) {
              this.isSpinShow = true;
              //用户是否登录
              centreInfoWeb().then(res => {
                if (res.code === 200) {
                  //获取工作分
                  myWorkPage().then(res => {
                    if(res.code === 200) {
                      this.isSpinShow = false;
                      this.workScore = res.data.workScore;
                      this.workPer = parseInt(res.data.workScore) / parseInt(res.data.workScoreAll) * 100;
                      this.works = res.data.works;
                    }else {
                      this.isSpinShow = false;
                      this.$Notice.warning({
                        title: "个人中心提醒",
                        desc: res.info,
                        duration: 3,
                      });
                    }
                  })
                }else {
                  this.isSpinShow = false;
                }
              }).catch()
            }
          }
        },
        created() {
          this.getAblityJob()
        },
        components: {
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/center/ablity_job.vue